module.exports = __webpack_public_path__ + "img/rentycloudy-sm.67a95837.png";